export let LiveSiteClicksInsideDispatchModalButtonType = /*#__PURE__*/function (LiveSiteClicksInsideDispatchModalButtonType) {
  LiveSiteClicksInsideDispatchModalButtonType["PICKUP_TAB"] = "pickup_tab";
  LiveSiteClicksInsideDispatchModalButtonType["DELIVERY_TAB"] = "delivery_tab";
  LiveSiteClicksInsideDispatchModalButtonType["ADDRESS_INPUT"] = "address_input";
  LiveSiteClicksInsideDispatchModalButtonType["TIME_DROPDOWN"] = "time_dropdown";
  LiveSiteClicksInsideDispatchModalButtonType["TIME_DROPDOWN_OPTION"] = "time_dropdown_option";
  LiveSiteClicksInsideDispatchModalButtonType["DAY_DROPDOWN"] = "day_dropdown";
  LiveSiteClicksInsideDispatchModalButtonType["DAY_DROPDOWN_OPTION"] = "day_dropdown_option";
  LiveSiteClicksInsideDispatchModalButtonType["ASAP_RADIO_BUTTON"] = "asap_radio_button";
  LiveSiteClicksInsideDispatchModalButtonType["SCHEDULE_FOR_LATER_RADIO_BUTTON"] = "schedule_for_later_today_radio_button";
  LiveSiteClicksInsideDispatchModalButtonType["PICK_LOCATION"] = "pick_location";
  LiveSiteClicksInsideDispatchModalButtonType["CHANGE_LOCATION"] = "change_location";
  return LiveSiteClicksInsideDispatchModalButtonType;
}({});
//# sourceMappingURL=constants.js.map